const styles = (theme) => ({
  root: {},
  availabilityRow: {
    textAlign: 'center',
    alignSelf: 'center',
  },
});

export default styles;
